export default function InitVideo() {
  Array.from(document.querySelectorAll<HTMLElement>(".video"))
    .forEach(videoElement => {
      if (videoElement.dataset["bg"]) {
        videoElement.style.backgroundImage = videoElement.dataset["bg"]
      }
    })

  document.addEventListener("click", (event: Event) => {
    const target = event.target as HTMLElement
    const videoElement = target.closest<HTMLElement>(".video")

    if (videoElement && !videoElement.classList.contains("video--is-playing")) {
      videoElement.classList.add("video--is-playing")
      const videoHtml = videoElement.dataset["video"]
      const container = videoElement.querySelector(".video__container")
      if (container && videoHtml) {
        container.insertAdjacentHTML("beforeend", videoHtml)
      }
    }
  })
}
